import { createSelector } from 'reselect';

import { getLocation } from 'modules/router/selectors';

export const getCurrentLocation = createSelector(getLocation, ({ pathname }) => pathname);
export const getLocationState = createSelector(getLocation, ({ state }) => state);
export const getLocationSearch = createSelector(getLocation, ({ search }) => search);
